import { Font, FontFamily } from '@bynder-studio/structured-text';

export type UserState = {
    user: any;
    companies: any;
    permissions: string[];
    roles: string[];
    accessibleFeatures: string[];
    resetRequestFail: any;
    updateFail: any;
    currentCompany: number;
    timeZones: any[];
    isActivating: boolean;
    isActivated: boolean;
    tokenValdiationStatus: 'REQUEST' | 'SUCCESS' | 'FAIILURE';
    groups: string[];
    fonts: FontFamily[];
    defaultFontId: Font['id'] | undefined;
    splitFeatures: Record<ActiveSplits, 'on' | 'off' | 'control'>;
    updateSuccess?: boolean;
    loggingIn?: boolean;
    lastLoginFail?: boolean;
    bynderScopes?: any[];
};

export enum ActiveSplits {
    studioKongGateway = 'studio_kong_gateway',
    imageGenAsyncProcessing = 'image_gen_async_processing',
    studioDsColorPicker = 'studio_ds_colorpicker',
    studioTextOutlineColor = 'studio_text_outline_color',
    studioSelfFontManagement = 'studio_self_font_management',
    studioExtendedImageDimensions = 'studio_extended_image_dimensions',
    studioImageCropModeLock = 'studio_image_crop_mode_lock',
    studioMultipleTemplateCategories = 'studio_multiple_template_categories',
    studioElementSelectionInCc = 'studio_element_selection_in_cc',
}
